module.exports = __webpack_public_path__ + "img/Landing_Mobile.d83fa182.png";